import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, withKeys as _withKeys, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-61c99a8c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "marcas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "marcas-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Gestión de Desplegables", -1 /* HOISTED */));
const _hoisted_6 = { class: "header-top-controls" };
const _hoisted_7 = { class: "search-container" };
const _hoisted_8 = { class: "search-wrapper" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Generar Reporte", -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Nuevo Desplegable", -1 /* HOISTED */));
const _hoisted_11 = { class: "table-container" };
const _hoisted_12 = { class: "marcas-table" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Nombre del Atributo"),
        /*#__PURE__*/ _createElementVNode("th", null, "Tipo"),
        /*#__PURE__*/ _createElementVNode("th", null, "Unidad"),
        /*#__PURE__*/ _createElementVNode("th", null, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_14 = { key: 0 };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "4",
    class: "text-center py-4"
}, "Cargando datos...", -1 /* HOISTED */));
const _hoisted_16 = [
    _hoisted_15
];
const _hoisted_17 = { key: 1 };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "4",
    class: "text-center py-4 text-muted"
}, "No se encontraron resultados.", -1 /* HOISTED */));
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = { class: "attribute-badge" };
const _hoisted_21 = {
    key: 0,
    class: "unidad-chip"
};
const _hoisted_22 = {
    key: 1,
    class: "text-muted-sm"
};
const _hoisted_23 = { class: "actions-column" };
const _hoisted_24 = ["onClick", "title"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { class: "pagination-controls" };
const _hoisted_29 = ["disabled"];
const _hoisted_30 = ["disabled"];
const _hoisted_31 = { class: "total-count-display" };
const _hoisted_32 = { class: "modal-window" };
const _hoisted_33 = { class: "modal-header" };
const _hoisted_34 = { class: "modal-title-group" };
const _hoisted_35 = { class: "icon-bg" };
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "modal-description" }, " Define el nombre, tipo y unidad del atributo. ", -1 /* HOISTED */));
const _hoisted_37 = {
    class: "form-group premium-input",
    style: { "margin-bottom": "16px" }
};
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "nombre" }, "Nombre del Atributo", -1 /* HOISTED */));
const _hoisted_39 = { class: "input-with-icon" };
const _hoisted_40 = {
    class: "form-group",
    style: { "margin-bottom": "16px" }
};
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo de Atributo", -1 /* HOISTED */));
const _hoisted_42 = { class: "tipo-grid" };
const _hoisted_43 = ["onClick"];
const _hoisted_44 = { class: "tipo-card-label" };
const _hoisted_45 = {
    key: 0,
    class: "form-section-row"
};
const _hoisted_46 = {
    class: "form-group",
    style: { "flex": "2", "margin-bottom": "16px" }
};
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Unidad de Medida", -1 /* HOISTED */));
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: null }, "— Sin unidad —", -1 /* HOISTED */));
const _hoisted_49 = ["label"];
const _hoisted_50 = ["value"];
const _hoisted_51 = {
    class: "form-group",
    style: { "flex": "1", "margin-bottom": "16px", "margin-left": "10px" }
};
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Decimales", -1 /* HOISTED */));
const _hoisted_53 = { class: "input-with-icon" };
const _hoisted_54 = {
    class: "modal-footer",
    style: { "padding": "0", "margin-top": "8px", "background": "transparent" }
};
const _hoisted_55 = {
    type: "submit",
    class: "btn-save-modal"
};
const _hoisted_56 = { class: "modal-window large-modal" };
const _hoisted_57 = { class: "modal-header" };
const _hoisted_58 = { class: "modal-title-group" };
const _hoisted_59 = { class: "icon-bg purple" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Gestión de Valores", -1 /* HOISTED */));
const _hoisted_61 = { class: "subtitle" };
const _hoisted_62 = { class: "modal-body" };
const _hoisted_63 = { class: "add-value-box" };
const _hoisted_64 = {
    class: "input-group",
    style: { "align-items": "center", "gap": "10px", "display": "flex" }
};
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: null }, "Sin clasificación", -1 /* HOISTED */));
const _hoisted_66 = ["value"];
const _hoisted_67 = ["disabled"];
const _hoisted_68 = {
    class: "search-container",
    style: { "margin-bottom": "15px", "width": "100%", "display": "flex", "gap": "10px" }
};
const _hoisted_69 = {
    class: "search-wrapper",
    style: { "flex": "2" }
};
const _hoisted_70 = {
    key: 0,
    class: "filter-wrapper",
    style: { "flex": "1" }
};
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: null }, "Todas las clasificaciones", -1 /* HOISTED */));
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: 0 }, "Sin clasificación", -1 /* HOISTED */));
const _hoisted_73 = ["value"];
const _hoisted_74 = { class: "values-list-container" };
const _hoisted_75 = { class: "marcas-table mini-table" };
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "width": "40%" } }, "Valor", -1 /* HOISTED */));
const _hoisted_77 = {
    key: 0,
    style: { "width": "25%" }
};
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { style: { "width": "15%" } }, "Estado", -1 /* HOISTED */));
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", {
    class: "text-right",
    style: { "width": "20%" }
}, "Acciones", -1 /* HOISTED */));
const _hoisted_80 = { style: { "font-weight": "600", "color": "#1e293b" } };
const _hoisted_81 = { key: 0 };
const _hoisted_82 = {
    key: 0,
    class: "attribute-badge border border-primary/20 bg-blue-50 text-blue-700 font-medium"
};
const _hoisted_83 = {
    key: 1,
    class: "text-muted-sm"
};
const _hoisted_84 = { class: "actions-column" };
const _hoisted_85 = ["onClick", "title"];
const _hoisted_86 = ["onClick"];
const _hoisted_87 = ["onClick"];
const _hoisted_88 = { key: 0 };
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "4",
    class: "text-center text-muted",
    style: { "padding": "20px" }
}, "No se encontraron resultados.", -1 /* HOISTED */));
const _hoisted_90 = [
    _hoisted_89
];
const _hoisted_91 = { class: "modal-footer" };
const _hoisted_92 = { class: "modal-window export-modal premium-modal" };
const _hoisted_93 = { class: "modal-header" };
const _hoisted_94 = { class: "modal-title-group" };
const _hoisted_95 = { class: "icon-bg excel-bg" };
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title" }, "Generar Reporte"),
    /*#__PURE__*/ _createElementVNode("p", { class: "modal-subtitle" }, "Seleccione los parámetros del reporte")
], -1 /* HOISTED */));
const _hoisted_97 = { class: "modal-body" };
const _hoisted_98 = { class: "export-info-card" };
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Seleccione las columnas que desea incluir. Los filtros aplicados actualmente se mantendrán en el reporte.", -1 /* HOISTED */));
const _hoisted_100 = { class: "export-section" };
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Formato de Salida", -1 /* HOISTED */));
const _hoisted_102 = { class: "export-format-grid" };
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "export-format-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-name" }, "Excel (.xlsx)"),
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-desc" }, "Hoja de cálculo editable")
], -1 /* HOISTED */));
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "export-format-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-name" }, "PDF (.pdf)"),
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-desc" }, "Documento listo para imprimir")
], -1 /* HOISTED */));
const _hoisted_105 = {
    class: "export-section",
    style: { "margin-top": "24px" }
};
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Ordenar Por", -1 /* HOISTED */));
const _hoisted_107 = {
    class: "export-format-grid",
    style: { "grid-template-columns": "2fr 1fr", "gap": "10px" }
};
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Atributo" }, "Nombre del Atributo", -1 /* HOISTED */));
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Valor" }, "Valor", -1 /* HOISTED */));
const _hoisted_110 = [
    _hoisted_108,
    _hoisted_109
];
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "asc" }, "Ascendente", -1 /* HOISTED */));
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "desc" }, "Descendente", -1 /* HOISTED */));
const _hoisted_113 = [
    _hoisted_111,
    _hoisted_112
];
const _hoisted_114 = {
    class: "export-section",
    style: { "margin-top": "24px" }
};
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Columnas a Incluir", -1 /* HOISTED */));
const _hoisted_116 = { class: "columns-selection-grid" };
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "column-selection-header" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "header-order" }, "#"),
    /*#__PURE__*/ _createElementVNode("span", { class: "header-name" }, "Columna")
], -1 /* HOISTED */));
const _hoisted_118 = { class: "column-order-badge" };
const _hoisted_119 = {
    class: "drag-handle",
    title: "Arrastrar para reordenar"
};
const _hoisted_120 = { class: "checkbox-wrapper" };
const _hoisted_121 = ["value"];
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "checkmark" }, null, -1 /* HOISTED */));
const _hoisted_123 = { class: "column-details" };
const _hoisted_124 = { class: "column-name" };
const _hoisted_125 = { class: "modal-footer" };
const _hoisted_126 = ["disabled"];
const _hoisted_127 = { key: 0 };
const _hoisted_128 = {
    key: 1,
    class: "btn-content"
};
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Generar Reporte", -1 /* HOISTED */));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_FileTextIcon = _resolveComponent("FileTextIcon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_AlphabetFilter = _resolveComponent("AlphabetFilter");
    const _component_PowerIcon = _resolveComponent("PowerIcon");
    const _component_ListIcon = _resolveComponent("ListIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon");
    const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon");
    const _component_TagIcon = _resolveComponent("TagIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_TypeIcon = _resolveComponent("TypeIcon");
    const _component_HashIcon = _resolveComponent("HashIcon");
    const _component_LoaderIcon = _resolveComponent("LoaderIcon");
    const _component_DownloadIcon = _resolveComponent("DownloadIcon");
    const _component_InfoIcon = _resolveComponent("InfoIcon");
    const _component_GripVerticalIcon = _resolveComponent("GripVerticalIcon");
    const _component_draggable = _resolveComponent("draggable");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_SearchIcon, {
                                    size: 18,
                                    class: "search-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchQuery) = $event)),
                                    placeholder: "Buscar atributo...",
                                    class: "search-input"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, $setup.searchQuery]
                                ])
                            ])
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => ($setup.openExportModal && $setup.openExportModal(...args))),
                            class: "btn btn-export-premium"
                        }, [
                            _createVNode(_component_FileTextIcon, { size: 18 }),
                            _hoisted_9
                        ]),
                        ($setup.hasPermission('SETTINGS_CREATE'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[2] || (_cache[2] = ($event) => ($setup.openModal())),
                                class: "btn btn-add"
                            }, [
                                _createVNode(_component_PlusIcon, { size: 18 }),
                                _hoisted_10
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createVNode(_component_AlphabetFilter, {
                        modelValue: $setup.selectedLetter,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.selectedLetter) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("table", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("tbody", null, [
                            ($setup.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _hoisted_16))
                                : ($setup.paginatedDesplegables.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
                                    : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedDesplegables, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: item.nombreAtributoID
                                }, [
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_20, _toDisplayString(item.nombreAtributo), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["tipo-badge", 'tipo-' + item.tipoAtributo])
                                        }, _toDisplayString($setup.tipoLabel(item.tipoAtributo)), 3 /* TEXT, CLASS */)
                                    ]),
                                    _createElementVNode("td", null, [
                                        (item.unidad)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.unidad.simbolo), 1 /* TEXT */))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_22, "—"))
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["status-badge", item.active !== false ? 'active' : 'inactive'])
                                        }, _toDisplayString(item.active !== false ? 'Activo' : 'Inactivo'), 3 /* TEXT, CLASS */)
                                    ]),
                                    _createElementVNode("td", _hoisted_23, [
                                        _createElementVNode("button", {
                                            onClick: ($event) => ($setup.toggleActive(item)),
                                            class: "btn-icon btn-toggle",
                                            title: item.active !== false ? 'Desactivar' : 'Activar'
                                        }, [
                                            _createVNode(_component_PowerIcon, {
                                                size: 18,
                                                class: _normalizeClass(item.active !== false ? 'text-success' : 'text-danger')
                                            }, null, 8 /* PROPS */, ["class"])
                                        ], 8 /* PROPS */, _hoisted_24),
                                        (item.tipoAtributo === 'desplegable')
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: ($event) => ($setup.openValoresModal(item)),
                                                class: "btn-icon btn-view",
                                                title: "Gestionar Valores"
                                            }, [
                                                _createVNode(_component_ListIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_25))
                                            : _createCommentVNode("v-if", true),
                                        ($setup.hasPermission('SETTINGS_EDIT'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                onClick: ($event) => ($setup.editDesplegable(item)),
                                                class: "btn-icon btn-edit",
                                                title: "Editar"
                                            }, [
                                                _createVNode(_component_EditIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_26))
                                            : _createCommentVNode("v-if", true),
                                        ($setup.hasPermission('SETTINGS_DELETE'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                onClick: ($event) => ($setup.confirmDeleteDesplegable(item.nombreAtributoID)),
                                                class: "btn-icon btn-delete",
                                                title: "Eliminar"
                                            }, [
                                                _createVNode(_component_TrashIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_27))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                        disabled: $setup.currentPage === 1,
                        class: "btn-pagination"
                    }, [
                        _createVNode(_component_ChevronLeftIcon, { size: 16 }),
                        _createTextVNode(" Anterior ")
                    ], 8 /* PROPS */, _hoisted_29),
                    _createElementVNode("span", null, [
                        _createTextVNode("Página "),
                        _createElementVNode("strong", null, _toDisplayString($setup.currentPage), 1 /* TEXT */),
                        _createTextVNode(" de "),
                        _createElementVNode("strong", null, _toDisplayString($setup.totalPages), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                        disabled: $setup.currentPage === $setup.totalPages,
                        class: "btn-pagination"
                    }, [
                        _createTextVNode(" Siguiente "),
                        _createVNode(_component_ChevronRightIcon, { size: 16 })
                    ], 8 /* PROPS */, _hoisted_30)
                ]),
                _createElementVNode("div", _hoisted_31, " Total Registros: " + _toDisplayString($setup.totalDesplegablesCount), 1 /* TEXT */),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isModalOpen)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: _cache[12] || (_cache[12] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.closeModal && $setup.closeModal(...args)), ["self"]))
                            }, [
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("div", _hoisted_35, [
                                                _createVNode(_component_TagIcon, {
                                                    size: 24,
                                                    class: "text-primary"
                                                })
                                            ]),
                                            _createElementVNode("h2", null, _toDisplayString($setup.isEditing ? 'Editar Atributo' : 'Nuevo Atributo'), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[6] || (_cache[6] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("form", {
                                        onSubmit: _cache[11] || (_cache[11] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => ($setup.saveDesplegable && $setup.saveDesplegable(...args)), ["prevent"])),
                                        class: "modal-body"
                                    }, [
                                        _hoisted_36,
                                        _createCommentVNode(" Nombre "),
                                        _createElementVNode("div", _hoisted_37, [
                                            _hoisted_38,
                                            _createElementVNode("div", _hoisted_39, [
                                                _createVNode(_component_TypeIcon, {
                                                    size: 18,
                                                    class: "input-icon"
                                                }),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (($setup.currentForm.nombreAtributo) = $event)),
                                                    id: "nombre",
                                                    placeholder: "Ej: Largo, Color, Peso",
                                                    required: "",
                                                    class: "form-control"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.currentForm.nombreAtributo]
                                                ])
                                            ])
                                        ]),
                                        _createCommentVNode(" Tipo "),
                                        _createElementVNode("div", _hoisted_40, [
                                            _hoisted_41,
                                            _createElementVNode("div", _hoisted_42, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tiposAtributo, (t) => {
                                                    return (_openBlock(), _createElementBlock("label", {
                                                        key: t.value,
                                                        class: _normalizeClass(["tipo-card", { active: $setup.currentForm.tipoAtributo === t.value }]),
                                                        onClick: ($event) => { $setup.currentForm.tipoAtributo = t.value; if (t.value !== 'numerico' && t.value !== 'rango')
                                                            $setup.currentForm.unidadID = null; }
                                                    }, [
                                                        (_openBlock(), _createBlock(_resolveDynamicComponent(t.icon), {
                                                            size: 20,
                                                            class: "tipo-card-icon"
                                                        })),
                                                        _createElementVNode("span", _hoisted_44, _toDisplayString(t.label), 1 /* TEXT */)
                                                    ], 10 /* CLASS, PROPS */, _hoisted_43));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ]),
                                        _createCommentVNode(" Unidad (solo numerico / rango) "),
                                        ($setup.currentForm.tipoAtributo === 'numerico' || $setup.currentForm.tipoAtributo === 'rango')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                _createElementVNode("div", _hoisted_46, [
                                                    _hoisted_47,
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($setup.currentForm.unidadID) = $event)),
                                                        class: "form-control-select"
                                                    }, [
                                                        _hoisted_48,
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.unidadesPorCategoria, (cat) => {
                                                            return (_openBlock(), _createElementBlock("optgroup", {
                                                                key: cat.categoria,
                                                                label: cat.categoria.toUpperCase()
                                                            }, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.unidades, (u) => {
                                                                    return (_openBlock(), _createElementBlock("option", {
                                                                        key: u.unidadID,
                                                                        value: u.unidadID
                                                                    }, _toDisplayString(u.simbolo) + " — " + _toDisplayString(u.nombre), 9 /* TEXT, PROPS */, _hoisted_50));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ], 8 /* PROPS */, _hoisted_49));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ], 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, $setup.currentForm.unidadID]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_51, [
                                                    _hoisted_52,
                                                    _createElementVNode("div", _hoisted_53, [
                                                        _createVNode(_component_HashIcon, {
                                                            size: 18,
                                                            class: "input-icon"
                                                        }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (($setup.currentForm.decimales) = $event)),
                                                            min: "0",
                                                            max: "5",
                                                            class: "form-control",
                                                            placeholder: "0"
                                                        }, null, 512 /* NEED_PATCH */), [
                                                            [
                                                                _vModelText,
                                                                $setup.currentForm.decimales,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_54, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[10] || (_cache[10] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                                class: "btn-cancel-modal"
                                            }, "Cancelar"),
                                            _createElementVNode("button", _hoisted_55, _toDisplayString($setup.isEditing ? 'Guardar Cambios' : 'Crear Atributo'), 1 /* TEXT */)
                                        ])
                                    ], 32 /* NEED_HYDRATION */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isModalOpenValores)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: _cache[22] || (_cache[22] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.closeValoresModal && $setup.closeValoresModal(...args)), ["self"]))
                            }, [
                                _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, [
                                                _createVNode(_component_ListIcon, {
                                                    size: 24,
                                                    class: "text-purple"
                                                })
                                            ]),
                                            _createElementVNode("div", null, [
                                                _hoisted_60,
                                                _createElementVNode("span", _hoisted_61, [
                                                    _createTextVNode("Para: "),
                                                    _createElementVNode("strong", null, _toDisplayString($setup.currentValor?.nombreAtributo), 1 /* TEXT */)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[13] || (_cache[13] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeValoresModal && $setup.closeValoresModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_62, [
                                        _createElementVNode("div", _hoisted_63, [
                                            _createElementVNode("div", _hoisted_64, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => (($setup.valorForm.valor) = $event)),
                                                    placeholder: "Nuevo valor (Ej: Rojo, XL, Acero)",
                                                    class: "form-control",
                                                    style: { "flex": "2" },
                                                    onKeyup: _cache[15] || (_cache[15] = _withKeys(
                                                    //@ts-ignore
                                                    (...args) => ($setup.handleSubmitValor && $setup.handleSubmitValor(...args)), ["enter"]))
                                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [_vModelText, $setup.valorForm.valor]
                                                ]),
                                                ($setup.isMarcaDropdown)
                                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                        key: 0,
                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => (($setup.valorForm.clasificacionMarcaId) = $event)),
                                                        class: "form-control",
                                                        style: { "flex": "1", "min-width": "160px", "height": "44px", "border": "1px solid #cbd5e1", "box-shadow": "inset 0 1px 2px rgba(0,0,0,0.05)", "border-radius": "8px", "padding": "0 14px", "cursor": "pointer", "color": "#334155", "font-weight": "500", "appearance": "none", "background-image": "url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%2394a3b8%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')", "background-repeat": "no-repeat", "background-position": "right 14px center", "background-size": "10px auto", "background-color": "white" }
                                                    }, [
                                                        _hoisted_65,
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.clasis, (c) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: c.clasificacionMarcaId,
                                                                value: c.clasificacionMarcaId
                                                            }, _toDisplayString(c.nombre), 9 /* TEXT, PROPS */, _hoisted_66));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ], 512 /* NEED_PATCH */)), [
                                                        [_vModelSelect, $setup.valorForm.clasificacionMarcaId]
                                                    ])
                                                    : _createCommentVNode("v-if", true),
                                                _createElementVNode("button", {
                                                    onClick: _cache[17] || (_cache[17] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.handleSubmitValor && $setup.handleSubmitValor(...args))),
                                                    class: "btn-add-value",
                                                    disabled: $setup.isSavingValor,
                                                    style: { "flex": "0 0 auto", "min-width": "130px", "transition": "all 0.3s ease" }
                                                }, [
                                                    ($setup.isSavingValor)
                                                        ? (_openBlock(), _createBlock(_component_LoaderIcon, {
                                                            key: 0,
                                                            size: 16,
                                                            class: "spin-animation"
                                                        }))
                                                        : (_openBlock(), _createBlock(_component_PlusIcon, {
                                                            key: 1,
                                                            size: 16
                                                        })),
                                                    _createTextVNode(" " + _toDisplayString($setup.isSavingValor ? 'Guardando...' : ($setup.isEditingValor ? 'Actualizar' : 'Agregar')), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_67),
                                                ($setup.isEditingValor)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        onClick: _cache[18] || (_cache[18] =
                                                            //@ts-ignore
                                                            (...args) => ($setup.cancelEditValor && $setup.cancelEditValor(...args))),
                                                        class: "btn-cancel-mini",
                                                        style: { "flex": "0 0 auto" }
                                                    }, [
                                                        _createVNode(_component_XIcon, { size: 16 })
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_68, [
                                            _createElementVNode("div", _hoisted_69, [
                                                _createVNode(_component_SearchIcon, {
                                                    size: 18,
                                                    class: "search-icon"
                                                }),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => (($setup.searchValorQuery) = $event)),
                                                    placeholder: "Buscar valor...",
                                                    class: "search-input"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.searchValorQuery]
                                                ])
                                            ]),
                                            ($setup.isMarcaDropdown)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => (($setup.filterClasificacionId) = $event)),
                                                        class: "form-control",
                                                        style: { "height": "40px", "border": "1px solid #e2e8f0", "border-radius": "8px", "padding": "0 10px", "font-size": "0.9rem", "width": "100%" }
                                                    }, [
                                                        _hoisted_71,
                                                        _hoisted_72,
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.clasis, (c) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: c.clasificacionMarcaId,
                                                                value: c.clasificacionMarcaId
                                                            }, _toDisplayString(c.nombre), 9 /* TEXT, PROPS */, _hoisted_73));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ], 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, $setup.filterClasificacionId]
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("table", _hoisted_75, [
                                                _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                        _hoisted_76,
                                                        ($setup.isMarcaDropdown)
                                                            ? (_openBlock(), _createElementBlock("th", _hoisted_77, "Clasificación"))
                                                            : _createCommentVNode("v-if", true),
                                                        _hoisted_78,
                                                        _hoisted_79
                                                    ])
                                                ]),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredValores, (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: item.valorID
                                                        }, [
                                                            _createElementVNode("td", _hoisted_80, _toDisplayString(item.valor), 1 /* TEXT */),
                                                            ($setup.isMarcaDropdown)
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_81, [
                                                                    (item.clasificacionMarca?.nombre)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(item.clasificacionMarca.nombre), 1 /* TEXT */))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_83, "—"))
                                                                ]))
                                                                : _createCommentVNode("v-if", true),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["status-badge", item.active !== false ? 'active' : 'inactive'])
                                                                }, _toDisplayString(item.active !== false ? 'Activo' : 'Inactivo'), 3 /* TEXT, CLASS */)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_84, [
                                                                _createElementVNode("button", {
                                                                    onClick: ($event) => ($setup.toggleActiveValor(item)),
                                                                    class: "btn-icon btn-toggle",
                                                                    title: item.active !== false ? 'Desactivar' : 'Activar'
                                                                }, [
                                                                    _createVNode(_component_PowerIcon, {
                                                                        size: 14,
                                                                        class: _normalizeClass(item.active !== false ? 'text-success' : 'text-danger')
                                                                    }, null, 8 /* PROPS */, ["class"])
                                                                ], 8 /* PROPS */, _hoisted_85),
                                                                _createElementVNode("button", {
                                                                    onClick: ($event) => ($setup.startEditValor(item)),
                                                                    class: "btn-icon btn-edit-mini"
                                                                }, [
                                                                    _createVNode(_component_EditIcon, { size: 14 })
                                                                ], 8 /* PROPS */, _hoisted_86),
                                                                _createElementVNode("button", {
                                                                    onClick: ($event) => ($setup.confirmDeleteValor(item.valorID)),
                                                                    class: "btn-icon btn-delete-mini"
                                                                }, [
                                                                    _createVNode(_component_TrashIcon, { size: 14 })
                                                                ], 8 /* PROPS */, _hoisted_87)
                                                            ])
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */)),
                                                    ($setup.filteredValores.length === 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_88, _hoisted_90))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_91, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[21] || (_cache[21] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeValoresModal && $setup.closeValoresModal(...args))),
                                            class: "btn-save-modal full-width"
                                        }, " Finalizar ")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" Modal Exportar Excel con Diseño Premium "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isExportModalOpen)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: _cache[32] || (_cache[32] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args)), ["self"]))
                            }, [
                                _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("div", _hoisted_93, [
                                        _createElementVNode("div", _hoisted_94, [
                                            _createElementVNode("div", _hoisted_95, [
                                                _createVNode(_component_DownloadIcon, {
                                                    size: 24,
                                                    class: "text-excel"
                                                })
                                            ]),
                                            _hoisted_96
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[23] || (_cache[23] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_97, [
                                        _createElementVNode("div", _hoisted_98, [
                                            _createVNode(_component_InfoIcon, {
                                                size: 18,
                                                class: "text-primary"
                                            }),
                                            _hoisted_99
                                        ]),
                                        _createElementVNode("div", _hoisted_100, [
                                            _hoisted_101,
                                            _createElementVNode("div", _hoisted_102, [
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["export-format-card", { active: $setup.exportConfig.format === 'excel' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => (($setup.exportConfig.format) = $event)),
                                                        value: "excel",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.format]
                                                    ]),
                                                    _hoisted_103
                                                ], 2 /* CLASS */),
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["export-format-card", { active: $setup.exportConfig.format === 'pdf' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => (($setup.exportConfig.format) = $event)),
                                                        value: "pdf",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.format]
                                                    ]),
                                                    _hoisted_104
                                                ], 2 /* CLASS */)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_105, [
                                            _hoisted_106,
                                            _createElementVNode("div", _hoisted_107, [
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => (($setup.exportConfig.sortColumn) = $event)),
                                                    class: "form-control",
                                                    style: { "background-color": "#f8fafc", "border": "1px solid #e2e8f0", "border-radius": "8px", "padding": "12px", "font-size": "0.95rem", "color": "#1e293b", "outline": "none", "transition": "border-color 0.2s, box-shadow 0.2s", "cursor": "pointer" }
                                                }, _hoisted_110, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, $setup.exportConfig.sortColumn]
                                                ]),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => (($setup.exportConfig.sortDirection) = $event)),
                                                    class: "form-control",
                                                    style: { "background-color": "#f8fafc", "border": "1px solid #e2e8f0", "border-radius": "8px", "padding": "12px", "font-size": "0.95rem", "color": "#1e293b", "outline": "none", "transition": "border-color 0.2s, box-shadow 0.2s", "cursor": "pointer" }
                                                }, _hoisted_113, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, $setup.exportConfig.sortDirection]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_114, [
                                            _hoisted_115,
                                            _createElementVNode("div", _hoisted_116, [
                                                _hoisted_117,
                                                _createVNode(_component_draggable, {
                                                    modelValue: $setup.availableColumns,
                                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => (($setup.availableColumns) = $event)),
                                                    "item-key": "name",
                                                    handle: ".drag-handle",
                                                    class: "draggable-columns-list"
                                                }, {
                                                    item: _withCtx(({ element: column, index }) => [
                                                        _createElementVNode("label", {
                                                            class: _normalizeClass(["column-checkbox-card", { active: $setup.exportConfig.selectedColumns.includes(column.name) }])
                                                        }, [
                                                            _createElementVNode("div", _hoisted_118, _toDisplayString(index + 1), 1 /* TEXT */),
                                                            _createElementVNode("div", _hoisted_119, [
                                                                _createVNode(_component_GripVerticalIcon, { size: 16 })
                                                            ]),
                                                            _createElementVNode("div", _hoisted_120, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "checkbox",
                                                                    value: column.name,
                                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => (($setup.exportConfig.selectedColumns) = $event))
                                                                }, null, 8 /* PROPS */, _hoisted_121), [
                                                                    [_vModelCheckbox, $setup.exportConfig.selectedColumns]
                                                                ]),
                                                                _hoisted_122
                                                            ]),
                                                            _createElementVNode("div", _hoisted_123, [
                                                                _createElementVNode("span", _hoisted_124, _toDisplayString(column.name), 1 /* TEXT */)
                                                            ])
                                                        ], 2 /* CLASS */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ])
                                    ]),
                                    _createCommentVNode(" Close modal-body "),
                                    _createElementVNode("div", _hoisted_125, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[30] || (_cache[30] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args))),
                                            class: "btn-cancel-modal"
                                        }, "Cancelar"),
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[31] || (_cache[31] =
                                                //@ts-ignore
                                                (...args) => ($setup.handleExport && $setup.handleExport(...args))),
                                            class: "btn-save-modal btn-excel",
                                            disabled: $setup.isExporting
                                        }, [
                                            ($setup.isExporting)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_127, "Generando..."))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                                    _createVNode(_component_FileTextIcon, { size: 18 }),
                                                    _hoisted_129
                                                ]))
                                        ], 8 /* PROPS */, _hoisted_126)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ])
    ]));
}
